<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="绑定推荐官专员" prop="topUserId" >
        <a-select v-model="form.topUserId" property="请选择" optionFilterProp="children" showSearch>
          <a-select-option v-for="(topUser,index) in topUserList" :key="index" :value="topUser.id">{{topUser.nickname}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>

  </a-drawer>
</template>

<script>
import {queryUserByType, setStatus} from '@/api/biz/user'
import {updateReferrals} from "@/api/user/referrals";

export default {
  name: 'SetStatusForm',
  props: {
  },
  components: {

  },
  data () {
    return {
      uploading: false,
      submitLoading: false,
      formTitle: '',
      topUserList: [],
      fields: [],
      ids: null,
      fieldIndex: null,
      // 表单参数
      form: {
        id: null,
        topUserId: null
      },
      formType: 1,
      open: false,
      name: '',
      rules: {}
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.topUserList = []
      this.ids = null
      this.form = {
        id: null,
        topUserId: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (id) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '绑定专员'
      this.form.id = id
      const param = { type: 3 }
      queryUserByType(param).then(response => {
        this.topUserList = response.data
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          updateReferrals(this.form).then(response => {
            this.$message.success(
              '绑定成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table {
  thead {
    tr {
      th {
        padding: 6px 8px;
        color: #000;
        font-weight: 500;
        text-align: left;
        background: #fafafa;
        border: 1px solid #e8e8e8;
        transition: background 0.3s ease
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 12px 8px;
        color: #000;
        text-align: left;
        background: #fff;
        border: 1px solid #e8e8e8;
        transition: background 0.3s ease;
        word-break: break-word;
        line-height: 18px;
      }
    }
  }
}
</style>
